import { PageType, ReportPageTemplate } from '@blk/simba';

import { ADVISOR_LANDSCAPE_FOOTER, ADVISOR_LANDSCAPE_HEADER } from './advisor-template';

export const ADVISOR_LANDSCAPE_LAYOUT = (familyName, footerDcr, modelSubscriptLabel) => new ReportPageTemplate(ADVISOR_LANDSCAPE_HEADER(familyName, modelSubscriptLabel), ADVISOR_LANDSCAPE_FOOTER(footerDcr), Object.assign({}, PageType.LetterLandscape, { contentHeight: 505 }));

